/**
 * @module user/delete
 */

import {ClickEventController} from 'nova';
import {httpDelete} from '../../core/service/backend.js';
import {t} from '../../locale/config/translate.js';
import {coreFeature} from '../../core/config/feature.js';
import {user} from '../user.js';

/**
 * Delete Account Button
 *
 * @example
 *
 * ```html
 * <!--@ ${auth.delete} -->
 * <button>Delete</button>
 * ```
 */
const clickDelete = new ClickEventController(async (element) => {
  const question = await t('userPool.confirmDeletion');

  await coreFeature.popup(
    element,
    'confirm',
    (close) => ({
      question,
      yes: async () => {
        await httpDelete('user', element);
        location.search = `?spaRoute=%2FalternativeProducts%3Fuserid=${user.uid}`;
      },
      no: () => close(),
    }),
    true,
  );
});

export {clickDelete};
